// extracted by mini-css-extract-plugin
export default {"gridContainer":"ResolutionList_gridContainer__Kklfm"};